import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10","key":"svg-0"}],["path",{"d":"M9 19v-6","key":"svg-1"}],["path",{"d":"M8 5v8h2v-8","key":"svg-2"}],["path",{"d":"M15 19v-6","key":"svg-3"}],["path",{"d":"M14 5v8h2v-8","key":"svg-4"}]]

const IconPiano = createReactComponent('outline', 'piano', 'Piano', __iconNode);

export default IconPiano;